import { shouldShowCWQALog } from "../../../utils/shouldShowCWQALog";

interface CWUserAgeParams {
  csUserAge: {
    age_range: string;
  };
}

export const useCWuserAgeEvent = ({ csUserAge }: CWUserAgeParams): void => {
  const eventData = {
    age: csUserAge.age_range,
  };

  shouldShowCWQALog() && console.log(`cw_user_age event:`, eventData);
  window.gtag("event", "cw_user_age", eventData);
};